(ns app.reporting.code-report-model
  (:require [app.domain.group.model :as group-model]))

(def ^{:arglists '([authority-group])} group-mapping-sets
  (group-model/entities-of-group-fn :entity.type/code-report-mapping-set))

(defn mapping-text [{:code-report-mapping/keys [code description]}]
  (str "(" code ") " description))
